__turbopack_context__.v({
  "accordionToggle": "Roadmap-module__UVmZea__accordionToggle",
  "circleProgress": "Roadmap-module__UVmZea__circleProgress",
  "completed": "Roadmap-module__UVmZea__completed",
  "connectorLine": "Roadmap-module__UVmZea__connectorLine",
  "container": "Roadmap-module__UVmZea__container",
  "iconCircle": "Roadmap-module__UVmZea__iconCircle",
  "inProgress": "Roadmap-module__UVmZea__inProgress",
  "item": "Roadmap-module__UVmZea__item",
  "itemDescription": "Roadmap-module__UVmZea__itemDescription",
  "itemTitle": "Roadmap-module__UVmZea__itemTitle",
  "itemVisible": "Roadmap-module__UVmZea__itemVisible",
  "open": "Roadmap-module__UVmZea__open",
  "phase": "Roadmap-module__UVmZea__phase",
  "phaseContent": "Roadmap-module__UVmZea__phaseContent",
  "phaseHeader": "Roadmap-module__UVmZea__phaseHeader",
  "phaseIcon": "Roadmap-module__UVmZea__phaseIcon",
  "phaseItems": "Roadmap-module__UVmZea__phaseItems",
  "phaseItemsContainer": "Roadmap-module__UVmZea__phaseItemsContainer",
  "phaseOpen": "Roadmap-module__UVmZea__phaseOpen",
  "phaseStatus": "Roadmap-module__UVmZea__phaseStatus",
  "phaseTitle": "Roadmap-module__UVmZea__phaseTitle",
  "progressBar": "Roadmap-module__UVmZea__progressBar",
  "progressContainer": "Roadmap-module__UVmZea__progressContainer",
  "progressIndicator": "Roadmap-module__UVmZea__progressIndicator",
  "progressValue": "Roadmap-module__UVmZea__progressValue",
  "roadmap": "Roadmap-module__UVmZea__roadmap",
  "roadmapContent": "Roadmap-module__UVmZea__roadmapContent",
  "roadmapHeader": "Roadmap-module__UVmZea__roadmapHeader",
  "timelineProgress": "Roadmap-module__UVmZea__timelineProgress",
  "timelineTrack": "Roadmap-module__UVmZea__timelineTrack",
  "upcoming": "Roadmap-module__UVmZea__upcoming",
});
